<template>
  <div style="overflow-y: hidden" :style="{ height: scrollheight + 'px' }">
    <div class="history">
      <div
        class="scroll-cont"
        style="
          scrollbar-width: none;
          overflow-y: auto;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #828292;
          box-sizing: border-box;
        "
      >
        <div
          v-if="his_list.length == 0"
          style="
            color: gray;
            text-align: center;
            margin-top: 8px;
            font-size: 16px;
          "
        >
          暂无数据
        </div>
        <vue-loadmore
          :on-refresh="onRefresh"
          :on-loadmore="onLoad"
          :finished="finished"
          :finished-text="' '"
          class="his_item_container"
        >
          <div
            v-for="(item, i) in his_list"
            :key="i"
            class="his-item"
            style="display: inline-block; position: relative"
            @click="his_item_click(item.list)"
            v-on:mouseover="handleMouseOver(i)"
            v-on:mouseout="handleMouseOut(i)"
          >
            <el-image
              class="deleteIcon"
              style="
                width: 16px;
                height: 16px;
                cursor: pointer;
                position: absolute;
                top: 8px;
                right: 8px;
                z-index: 11;
              "
              :src="require('../assets/img/textform/delete.png')"
              fit="contain"
              @click.stop="deleteHis(i)"
            >
              <div slot="placeholder" class="image-slot"></div>
            </el-image>
            <div class="top_model"></div>
            <div
              class="d-flex"
              style="flex-wrap: wrap; justify-content: flex-start"
            >
              <template v-for="imgitem in item.list">
                <el-image
                  style="margin: 0; cursor: pointer"
                  :src="imgitem.image"
                  fit="contain"
                  :class="{
                    imgB1: item.list.length == 1,
                    imgB2: item.list.length == 2,
                    imgB3: item.list.length == 3,
                    imgB4: item.list.length == 4,
                  }"
                  :fit="'cover'"
                  v-if="imgitem.image"
                  @click.stop="imgClick(imgitem)"
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>
                <el-image
                  style="margin: 0; cursor: pointer"
                  :src="require('../assets/img/textform/forbid.png')"
                  fit="contain"
                  :class="{
                    imgB1: item.list.length == 1,
                    imgB2: item.list.length == 2,
                    imgB3: item.list.length == 3,
                    imgB4: item.list.length == 4,
                  }"
                  :fit="'cover'"
                  v-else
                >
                  <div slot="placeholder" class="image-slot"></div>
                </el-image>
              </template>
            </div>
          </div>
        </vue-loadmore>
      </div>
    </div>
  </div>
</template>

<script>
import {
  painting_page_req,
  painting_publish_req,
  painting_history_req,
  painting_cancel_req,
} from "@/api/personal";
import {
  img_page_req,
  task_interrupt_req,
  task_status_req,
  task_running_req,
  task_undoTask_req,
  img_del,
  painting_removeByTid,
} from "@/api/taskImage";
import {
  square_page_req,
  img_list_req,
  save_square_req,
  square_detail,
  painting_shareUrl,
} from "@/api/square";

export default {
  data() {
    return {
      // 下拉滚动相关
      pageNum: 1,
      pageSize: 100,
      his_list: [],
      finished: false,
      // 下拉滚动相关
      scrollheight: 500,
    };
  },
  methods: {
    // 历史记录相关 //
    onRefresh(done) {
      this.his_list = [];
      this.pageNum = 1;
      this.finished = false;
      this.img_page_get();
      done();
    },
    onLoad(done) {
      this.img_page_get();
      done();
    },
    // 获取历史记录
    img_page_get(params) {
      if (!this.tokenVuex) {
        return;
      }
      painting_history_req({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        category: 7,
        orderType: 1,
      }).then((res) => {
        if (res.success) {
          if (params && params.refresh == true) this.his_list = [];
          this.his_list = this.his_list.concat(res.data.records);
          if (this.pageNum >= res.data.pages) {
            this.finished = true;
            return;
          }
          this.pageNum++;
        } else {
          this.his_list = [];
          this.pageNum = 1;
        }
      });
    },
    his_item_click(list) {
      this.imgList = list;
      this.imgIdx = 0;
    },
    handleMouseOver(index) {
      this.isHover = true;
      this.hoverIdx = index;
    },
    handleMouseOut() {
      this.isHover = false;
      this.hoverIdx = undefined;
    },
    deleteHis(i) {
      if (this.img_create_loading) {
        return;
      }
      let taskId = this.his_list[i].taskId;

      this.$confirm("", "删除此条记录，您的作品也将一并删除，是否删除?", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        center: true,
        customClass: "_message_box2",
      })
        .then(({ value }) => {
          painting_removeByTid(taskId).then((res) => {
            this.$toast.open({
              message: "已删除",
              position: "top",
              duration: 3000,
              type: "success",
            });

            try {
              if (
                this.his_list[i].list[0].md5 &&
                this.imgList[0].md5 &&
                this.his_list[i].list[0].md5 == this.imgList[0].md5
              ) {
                this.imgList = [];
              }
            } catch (error) {
              console.error(error);
            }
            this.his_list.splice(i, 1);
          });
        })
        .catch(() => {
          // this.$toast.open({
          //     message: '删除失败，请稍后再试',
          //     position: 'top',
          //     duration: 1000,
          //     type: 'error',
          //   });
        });
    },
    imgClick(item) {
      if (item.md5) {
        painting_shareUrl({
          imgMd5: item.md5,
        }).then((res) => {
          // console.log( item.md5 );
          let obj = {};
          obj.router = "home";
          obj.share_url = item.md5;
          this.$router.push({
            name: "share", // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
            params: {
              url: res.data,
              md5: item.md5,
            },
          });
        });
      }
    },
  },
  mounted() {
    this.scrollheight = document.body.clientWidth - 370;
    this.$nextTick(() => {
      this.img_page_get();
    });
  },
  computed: {
    tokenVuex() {
      // 存储位置： store.state.{模块名,在store/index.js中module下的}.{state中定义的属性}
      return this.$store.state.user.token;
    },
  },
};
</script>

<style lang="scss" scoped>
.history {
  text-align: left;
  padding: 12px;
  box-sizing: border-box;
  font-size: 14px;
  overflow: hidden;
  height: 100%;

  .title {
    box-sizing: border-box;
    padding: 0 15px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    position: relative;
  }

  ::v-deep .el-tabs__item.is-active .title:after {
    content: "";
    display: block;
    width: 20px;
    height: 4px;
    background: #006fff;
    border-radius: 2px;
    position: absolute;
    bottom: 2px;
  }

  ::v-deep .el-tabs__active-bar {
    background-color: transparent !important;
  }

  ::v-deep .el-tabs__item.is-active .t1:after {
    left: 30px;
  }

  ::v-deep .el-tabs__item.is-active .t2:after {
    left: 37px;
  }

  ::v-deep .el-tabs__header.is-top {
    margin-bottom: 11px;
  }

  .scroll-cont {
    height: calc(100% - 25px);
    position: relative;
  }

  .scroll-cont {
    overflow: hidden;
  }

  .scroll-cont::-webkit-scrollbar {
    width: 5px;
    display: flex;
  }

  .scroll-cont::-webkit-scrollbar-thumb {
  }

  .scroll-cont:hover {
    overflow-y: auto;
  }

  .his-item {
    box-sizing: border-box;
    border-radius: 5px;
    flex-wrap: wrap;
    width: 200px;
    margin-bottom: 5px;
    align-content: stretch;
    position: relative;
    overflow: hidden;

    .imgB1 {
      width: 200px;
      height: 200px;
    }

    .imgB2 {
      width: 100px;
      height: 200px;
    }

    .imgB3 {
      width: 100px;
      height: 100px;
    }

    .imgB4 {
      width: 100px;
      height: 100px;
    }

    img {
      width: 50%;
      height: 50%;
    }

    .top_model {
      position: absolute;
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
      height: 34px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.7) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      z-index: 10;
      display: none;
    }

    .deleteIcon {
      display: none;
    }
  }

  .his-item {
    margin-right: 10px;
  }

  .his-item:hover {
    .top_model {
      display: block;
    }

    .deleteIcon {
      display: block;
    }
  }
}
</style>